export const METHOD_LOGIN_SSO = 'sso'
